
import { z } from 'zod';

export const estimateFormSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  description: z.string().optional(),
  customer_id: z.string().optional(),
  status: z.enum(['draft', 'sent', 'approved', 'rejected', 'expired']),
  tax_percentage: z.number().min(0).max(100),
  tax_inclusive: z.boolean(),
  // These fields are now optional initially - will be filled after line items
  special_instructions: z.string().optional(),
  payment_terms: z.string().optional(),
  validity_period: z.number().min(1).max(365).optional(),
  use_separate_site_address: z.boolean().default(false),
  site_street_address: z.string().optional(),
  site_suburb: z.string().optional(),
  site_city: z.string().optional(),
  site_province_state: z.string().optional(),
  site_postal_code: z.string().optional(),
});

// Schema for the final step (after line items)
export const estimateFinalStepSchema = z.object({
  special_instructions: z.string().optional(),
  payment_terms: z.string().optional(),
  validity_period: z.number().min(1).max(365),
});

export type EstimateFormValues = z.infer<typeof estimateFormSchema>;
export type EstimateFinalStepValues = z.infer<typeof estimateFinalStepSchema>;

export interface EstimateFormProps {
  estimateId?: string;
}
